export const ACTIVE = 'ACTIVE';
export const PASS = 'PASS';
export const REJECT = 'REJECT';
export const INVESTIGATION = 'INVESTIGATION';
export const WAITING = 'WAITING';
export const ERROR = 'ERROR';
export const OFFLINE = 'OFFINE';
export const RESERVED = 'RESERVED';
export const EMPTY = 'empty';